import { request } from '@/utils/request';

// 管理员信息类型
export interface AdminProfile {
  id: number;
  username: string;
  realName: string;
  phone: string;
  status: number;
  statusText: string;
  createTime: string;
}

// 修改个人信息参数
export interface UpdateProfileParams {
  realName?: string;
  phone?: string;
}

// 修改密码参数
export interface ChangePasswordParams {
  oldPassword: string;
  newPassword: string;
}

// 添加管理员参数
export interface AddAdminParams {
  username: string;
  password: string;
  realName?: string;
  phone?: string;
}

// 编辑管理员参数
export interface EditAdminParams {
  id: number;
  username?: string;
  realName?: string;
  phone?: string;
  status?: number;
}

// 分页响应类型
export interface PageResponse<T> {
  total: number;
  pages: number;
  current: number;
  size: number;
  records: T[];
}

export const profileApi = {
  // 获取当前管理员信息
  getInfo(): Promise<AdminProfile> {
    return request.get<AdminProfile>('/admin/profile/info');
  },

  // 静默校验当前 token 是否有效（用于路由守卫，不弹错误、不自动跳登录）
  validateToken(): Promise<void> {
    return request.get<void>('/admin/profile/info', { silent: true });
  },

  // 修改个人信息
  update(data: UpdateProfileParams): Promise<void> {
    return request.post('/admin/profile/update', data);
  },

  // 修改密码
  changePassword(data: ChangePasswordParams): Promise<void> {
    return request.post('/admin/profile/change-password', data);
  },

  // 管理员列表
  getList(params: {
    page?: number;
    size?: number;
    keyword?: string;
  }): Promise<PageResponse<AdminProfile>> {
    return request.get<PageResponse<AdminProfile>>('/admin/profile/list', { params });
  },

  // 获取管理员详情
  getDetail(id: number): Promise<AdminProfile> {
    return request.get<AdminProfile>(`/admin/profile/${id}`);
  },

  // 添加管理员
  add(data: AddAdminParams): Promise<AdminProfile> {
    return request.post<AdminProfile>('/admin/profile/add', data);
  },

  // 编辑管理员
  edit(data: EditAdminParams): Promise<void> {
    return request.post('/admin/profile/edit', data);
  },

  // 重置密码（可选传新密码）
  resetPassword(id: number, newPassword?: string): Promise<void> {
    return request.post(`/admin/profile/reset-password/${id}${newPassword ? '?newPassword=' + encodeURIComponent(newPassword) : ''}`);
  },

  // 删除管理员
  delete(id: number): Promise<void> {
    return request.post(`/admin/profile/delete/${id}`);
  },

  // 启用/禁用管理员
  toggleStatus(id: number): Promise<void> {
    return request.post(`/admin/profile/toggle-status/${id}`);
  }
};
